<script>
  import { onDestroy } from "svelte";
  import { lang } from '../lib/stores';
  export let data = {};
  export let totalWords = 0;
  export let totalText = 0;

  let selectedLang;
	const unsubscribe = lang.subscribe((value) => selectedLang = value);
  onDestroy(unsubscribe);

  $: data;
</script>

<section class="drugStats">
  <div class="p">
    <blockquote>
      <p>
        Ho la <em>ganja</em> che puzza di stanza, ah, scusa<br />
        La stanza che puzza di <em>ganja</em>, annusa
      </p>
      <p><small>Cazzo mene, Lunga Vita a Sto, 2017</small></p>
    </blockquote>
    <p>
      {#if selectedLang === 'it'}
        La droga, sempre presente nei quartieri, fin dai tempi di <a
          href="https://it.wikipedia.org/wiki/SxM"
          target="_blank">SXM</a
        >
        (il primo -e unico- bellissimo album dei
        <a
          href="https://it.wikipedia.org/wiki/Sangue_Misto_(gruppo_musicale)"
          target="_blank">Sangue Misto</a
        >
        del 1994) fa capolino qua e là in tutti gli album hip hop. Nel documentario
        del 2015
        <a href="https://www.mymovies.it/film/2015/numerozero/">Numero Zero</a>,
        diretto da Enrico Bisi,
        <a href="https://it.wikipedia.org/wiki/Danno_(rapper)" target="_blank"
          >Danno</a
        >
        dei
        <a href="https://it.wikipedia.org/wiki/Colle_der_Fomento" target="_blank"
          >Colle der Fomento</a
        >
        spiega perfettamente questa ossessione dei "rapper" per la marijuana, indicandola
        chiaramente come un elemento di differenziazione delle "hip hop heads" dai
        seguaci delle altre sottoculture giovanili (in sostanza: non confondeteci con
        quelli che calano e pippano, noi siamo diversi).<br />
        Questo attaccamento alle droghe cosiddette leggere è rimasto anche a
        trent'anni di distanza, e la cosa è evidente analizzando i termini con cui
        Ghali si riferisce alle droghe: i riferimenti alla marijuana, al fumo e alle
        loro diverse declinazioni sono molto più presenti rispetto a quelli ad altri
        tipi di droghe.
      {:else}
        Drugs, a constant presence in urban neighborhoods since the days of <a
          href="https://it.wikipedia.org/wiki/SxM"
          target="_blank">SXM</a
        > (the first —and only— brilliant album by <a
          href="https://it.wikipedia.org/wiki/Sangue_Misto_(gruppo_musicale)"
          target="_blank">Sangue Misto</a
        >, released in 1994), make occasional appearances
        throughout all hip-hop albums. In the 2015 documentary <a
        href="https://www.mymovies.it/film/2015/numerozero/">Numero Zero</a>, directed by Enrico
        Bisi, <a href="https://it.wikipedia.org/wiki/Danno_(rapper)" target="_blank"
          >Danno</a
        > of <a href="https://it.wikipedia.org/wiki/Colle_der_Fomento" target="_blank"
          >Colle der Fomento</a
        > perfectly explains rappers' obsession with marijuana,
        explicitly identifying it as a marker that sets "hip-hop heads" apart from followers of
        other youth subcultures (essentially: don’t confuse us with those who drop pills or
        snort coke—we are different).<br />
        This attachment to so-called "soft drugs" has endured even 30 years later, as becomes
        evident when analyzing the terms Ghali uses to reference drugs: mentions of marijuana,
        smoking, and their various forms are far more frequent than references to other types of drugs.
      {/if}
    </p>
    <blockquote>
      <p>
        <em>Marijuana</em> (Tiene zombie i ragazzi della noche)<br />
        <em>Marijuana</em> (Tornano tardi tutti senza voce)<br />
        <em>Marijuana</em> (È un chilo e mezzo, frate', ad occhio e croce)<br />
        <em>Marijuana</em> (Fumo con la testa in mezzo alle sue cosce)
      </p>
      <p><small>Marijuana, Lunga Vita a Sto, 2017</small></p>
    </blockquote>
    <p>
      {#if selectedLang === 'it'}
        Nei testi analizzati abbiamo trovato <em class="data"
          >{new Intl.NumberFormat("it-IT").format(data?.terms?.count ?? 0)}</em
        >
        parole che possono rappresentare diversi tipi di droga, circa lo
        <em class="data"
          >{new Intl.NumberFormat("it-IT").format(
            (data?.terms?.count / totalWords) * 100,
          )}%</em
        >
        del totale. Valutando tutta la lunghezza dei testi (<em class="data"
          >{new Intl.NumberFormat("it-IT").format(totalText)}</em
        >
        parole), questa percentuale scende allo
        <em class="data"
          >{new Intl.NumberFormat("it-IT").format(
            (data?.totalTerms / totalText) * 100,
          )}%</em
        >
        (<em class="data"
          >{new Intl.NumberFormat("it-IT").format(data?.totalTerms)}</em
        >
        termini).<br />
        Il brano con più riferimenti è
        <em>{data?.topSongs.detail.title ?? ""}</em>
        (<em class="data"
          >{new Intl.NumberFormat("it-IT").format(data?.topSongs.count ?? 0)}</em
        >
        ricorrenze) contenuto nell'abum
        <em>{data?.topSongs.album.title ?? ""}</em>
        del {data?.topSongs.album.year ?? ""}.
      {:else}
        In the analyzed texts we found <em class="data"
        >{new Intl.NumberFormat("en-US").format(data?.terms?.count ?? 0)}</em
      > 
        words that can represent different types of drugs, approximately
        <em class="data"
        >{new Intl.NumberFormat("en-US").format(
          (data?.terms?.count / totalWords) * 100,
        )}%</em
      >
        of the total. Evaluating the entire length of the texts ( <em class="data"><em class="data"
          >{new Intl.NumberFormat("en-US").format(totalText)}</em
        ></em> 
        words), this percentage drops to
        <em class="data"
        >{new Intl.NumberFormat("en-US").format(
          (data?.totalTerms / totalText) * 100,
        )}%</em
      > 
        ( <em class="data"
        >{new Intl.NumberFormat("en-US").format(data?.totalTerms)}</em
      > 
        terms). <br>
        The song with the most references is
        <em>{data?.topSongs.detail.title ?? ""}</em> 
        ( <em class="data"
        >{new Intl.NumberFormat("en-US").format(data?.topSongs.count ?? 0)}</em
      > 
        occurrences) contained in the album
        <em>{data?.topSongs.album.title ?? ""}</em> 
        of {data?.topSongs.album.year ?? ""}.
      {/if}
    </p>
  </div>
</section>

<style>
  .drugStats {
    display: block;
  }
</style>
